/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FreelancerResponse
 */
export interface FreelancerResponse {
    /**
     * 
     * @type {string}
     * @memberof FreelancerResponse
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof FreelancerResponse
     */
    fullname: string;
}

/**
 * Check if a given object implements the FreelancerResponse interface.
 */
export function instanceOfFreelancerResponse(value: object): value is FreelancerResponse {
    if (!('fullname' in value) || value['fullname'] === undefined) return false;
    return true;
}

export function FreelancerResponseFromJSON(json: any): FreelancerResponse {
    return FreelancerResponseFromJSONTyped(json, false);
}

export function FreelancerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FreelancerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'fullname': json['fullname'],
    };
}

export function FreelancerResponseToJSON(value?: FreelancerResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'fullname': value['fullname'],
    };
}

